// Tokens go in the fragment so they never reach CloudFront logs or Referer headers.
export const invitationLink = (token: string) =>
  `${window.location.origin}/invitation#${token}`;

export const passwordResetLink = (token: string) =>
  `${window.location.origin}/reset-password#${token}`;

export const tokenFromHash = (hash: string) => hash.replace(/^#/, "");
